'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { HubSpotFormModal } from '@/components/hubspot/HubSpotFormModal';
import { ArrowRight } from 'lucide-react';

const DEFAULT_FORM_ID = 'df2ee98e-b4a5-4e07-84da-e380bb35107c';

interface JobApplyButtonProps {
  jobTitle: string;
  applyUrl?: string;
}

export function JobApplyButton({ jobTitle, applyUrl }: JobApplyButtonProps) {
  const [contactOpen, setContactOpen] = useState(false);

  if (applyUrl) {
    return (
      <Button asChild size="lg">
        <a href={applyUrl} target="_blank" rel="noopener noreferrer">
          Apply Now
          <ArrowRight className="ml-0.5 h-4 w-4" />
        </a>
      </Button>
    );
  }

  return (
    <>
      <Button size="lg" onClick={() => setContactOpen(true)}>
        Apply Now
        <ArrowRight className="ml-0.5 h-4 w-4" />
      </Button>
      <HubSpotFormModal
        formId={DEFAULT_FORM_ID}
        open={contactOpen}
        onOpenChange={setContactOpen}
        title={`Apply for: ${jobTitle}`}
        description="Fill out the form below and our team will get back to you."
      />
    </>
  );
}
